import React from 'react';
import { fontSizes } from '../../constants/constants';
import MyFundsFunctional from './index.function.js';
import Text from '../../components/Text';
import Loader from '../../components/Loader';
import SubscribeCard from '../Subscribe/components/SubscribeCard.jsx';

const MyFunds = () => {
  const { TextWeight, getContentKey, fund_loading, my_funds, direction } =
    MyFundsFunctional();

  return (
    <div>
      <Text
        text={getContentKey('my_funds')}
        size={fontSizes.h24}
        weight={TextWeight.bold}
        color='text-black'
      />

      {fund_loading ? (
        <div className='w-full mx-auto mt-10'>
          <Loader />
        </div>
      ) : (
        my_funds?.fundMaster?.length > 0 ?
          <div
            dir={direction}
            className={'grid grid-cols-1 md:grid-cols-2 gap-5 mt-4'}
          >
            {my_funds?.fundMaster?.map((item, i) => (
              <SubscribeCard item={item} key={i} isFund />
            ))}
          </div>
          :
          <Text
            text={getContentKey('no_funds_found')}
            size={fontSizes.h16}
            isCenter
            className={'mt-10'}
          />
      )}
    </div>
  );
};

export default MyFunds;
